import * as Sentry from '@sentry/react'
import React from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

const { logger } = Sentry

export default function SentryNavigationTracker(): null {
  const location = useLocation()
  const navigationType = useNavigationType()
  const prevLocationRef = React.useRef(location.pathname)

  React.useEffect(() => {
    const from = prevLocationRef.current
    const to = location.pathname + location.search + location.hash

    logger.info(Sentry.logger.fmt`Navigation: ${from} -> ${to}.`)

    Sentry.addBreadcrumb({
      category: 'navigation',
      message: `Navigation to ${location.pathname}`,
      data: {
        from,
        to,
        navigationType,
        timestamp: new Date().toISOString(),
      },
      level: 'info',
    })
  }, [location, navigationType])

  return null
}

